import { useCheckoutSuccessRedirect } from "@/client/hooks/use-upgrade-checkout";

/**
 * Renders nothing. Its only job is to keep one `Checkout.Success` listener
 * alive for the lifetime of the app, so a buyer always reaches /billing/return
 * no matter which control opened the checkout — or whether that control
 * unmounted the moment it was clicked.
 */
export const CheckoutSuccessBridge = () => {
  useCheckoutSuccessRedirect();
  return null;
};
